import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "container p-0"
};
const _hoisted_2 = { class: "col-12 fw-bold" };
const _hoisted_3 = { class: "col-3 text-muted" };
const _hoisted_4 = { class: "col-9 text-dark" };
const _hoisted_5 = { class: "col-3 text-muted" };
const _hoisted_6 = { class: "col-7 text-dark" };
const _hoisted_7 = { class: "col-2 text-end fw-bold" };
const _hoisted_8 = { class: "col-1 text-center" };
const _hoisted_9 = { class: "col-7" };
const _hoisted_10 = { class: "col-2 text-center" };
const _hoisted_11 = { class: "col-2 text-end" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-solid" })
], -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = { class: "row" };
const _hoisted_15 = { class: "col-1 text-center" };
const _hoisted_16 = { class: "col-7" };
const _hoisted_17 = { class: "text-dark" };
const _hoisted_18 = /*#__PURE__*/ _createTextVNode();
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_21 = { class: "col-2 text-center" };
const _hoisted_22 = { class: "col-2 text-end" };
const _hoisted_23 = { class: "fw-bold" };
const _hoisted_24 = {
    key: 0,
    class: "fst-italic"
};
const _hoisted_25 = {
    key: 0,
    class: "row"
};
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "col-1" }, null, -1);
const _hoisted_27 = { class: "col-11" };
const _hoisted_28 = { class: "col-8 text-end text-muted" };
const _hoisted_29 = { class: "col-2 text-center" };
const _hoisted_30 = { class: "col-2 text-end" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-solid" })
], -1);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dotted" })
], -1);
const _hoisted_34 = [
    _hoisted_33
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_document_fields = _resolveComponent("g-document-fields", true);
    return (_ctx.fields)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (field._posType === 'caption')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(field.caption), 1)
                        ], 2))
                        : _createCommentVNode("", true),
                    (field._posType === 'value')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(field.caption), 1),
                            _createElementVNode("div", _hoisted_4, [
                                (field.hyperlink)
                                    ? (_openBlock(), _createBlock(_component_g_link, {
                                        key: 0,
                                        target: field.hyperlinkTarget,
                                        src: field.hyperlink
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(field.value), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["target", "src"]))
                                    : (field.badgeColor)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: _normalizeClass(["badge", field.badgeColor])
                                        }, _toDisplayString(field.value), 3))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode(_toDisplayString(field.value), 1)
                                        ], 64))
                            ])
                        ], 2))
                        : _createCommentVNode("", true),
                    (field._posType === 'value-amount')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(field.caption), 1),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(field.value), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$utils.formatNumberWithDcp(field.amount, field.amountDcp)), 1)
                        ], 2))
                        : _createCommentVNode("", true),
                    (field._posType === 'position-title')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["row", _ctx.rowClasses])
                            }, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(field.position), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(field.item), 1),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(field.quantity), 1),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(field.amount), 1)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass(["row", _ctx.rowClasses])
                            }, _hoisted_13, 2)
                        ], 64))
                        : _createCommentVNode("", true),
                    (field._posType === 'position')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(field.number), 1),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(field.itemNumber), 1),
                                    _hoisted_18,
                                    _hoisted_19,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.texte, (text) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            _createTextVNode(_toDisplayString(text) + " ", 1),
                                            _hoisted_20
                                        ], 64));
                                    }), 256))
                                ]),
                                _createElementVNode("div", _hoisted_21, _toDisplayString(field.quantity), 1),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$utils.formatNumberWithDcp(field.totalAmount, 2)), 1),
                                    (field.amount !== field.totalAmount)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "(" + _toDisplayString(_ctx.$utils.formatNumberWithDcp(field.amount, 2)) + ")", 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            (field.details && field.details.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_g_document_fields, {
                                            fields: field.details,
                                            "row-classes": "py-1-half"
                                        }, null, 8, ["fields"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : _createCommentVNode("", true),
                    (field._posType === 'total-amount')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 5,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(field.caption), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(field.currency), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(field.value), 1)
                        ], 2))
                        : _createCommentVNode("", true),
                    (field._posType === 'line')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 6,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, _hoisted_32, 2))
                        : _createCommentVNode("", true),
                    (field._posType === 'separator')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 7,
                            class: _normalizeClass(["row", _ctx.rowClasses])
                        }, _hoisted_34, 2))
                        : _createCommentVNode("", true)
                ], 64));
            }), 256))
        ]))
        : _createCommentVNode("", true);
}
